enum Registry {
  // brands
  facebook = 'e920',
  instagram = 'e929',
  spotify = 'e937',
  twitter = 'e93f',
  youtube = 'e945',
  facebookOutline = 'e91e',
  instagramOutline = 'e924',
  spotifyOutline = 'e927',
  twitterOutline = 'e92d',
  youtubeOutline = 'e92e',
  tikTokOutline = 'e974',

  // directional
  caretUp = 'e932',
  caretDown = 'e919',
  caretLeft = 'e933',
  caretRight = 'e934',
  caretCircleDown = 'e91b',
  chevronLeft = 'e92a',
  chevronRight = 'e93c',
  chevronUp = 'e93b',
  chevronDown = 'e931',
  moveVertical = 'e92c',
  arrowUp = 'e913',
  arrowLeft = 'e94a',
  arrowRight = 'e973',

  // status
  check = 'e938',
  checkCircle = 'e902',
  checkSquare = 'e944',
  alertCircle = 'e91a',
  alertTriangle = 'e901',

  // calendars & time
  calendar = 'e917',
  time = 'e93a',
  timeHand = 'e939',
  timeClockCircle = 'e974', // eslint-disable-line @typescript-eslint/no-duplicate-enum-values
  calendarAdd = 'e93d',

  // others
  byob = 'e908',
  close = 'e918',
  commercial = 'e915',
  disabled = 'e910',
  eye = 'e91c',
  video = 'e921',
  happyMask = 'e922',
  helpCircleOutline = 'e925',
  ellipsisHorizontal = 'e92b',
  no = 'e92f',
  pet = 'e907',
  readGlasses = 'e930',
  residential = 'e916',
  tree = 'e906',
  heartPulse = 'e91f',
  homeWorld = 'e923',
  travelWorld = 'e928',
  musicTicket = 'e926',
  musicLove = 'e91d',
  plus = 'e935',
  padlock = 'e936',
  padlockOutline = 'e95f',
  search = 'e830',
  music = 'e943',
  mail = 'e942',
  expandHorizontal = 'e93e',
  reset = 'e912',
  pencil = 'e904',
  trashCan = 'e958',
  fileFolder = 'e941',
  download = 'e95d',
  info = 'e90d',
  infoOutline = 'e949',
  feedback = 'e905',
  feedbackOutline = 'e948',
  media = 'e909',
  mediaOutline = 'e947',
  concert = 'e90a',
  concertOutline = 'e946',
  map = 'e914',
  mapOutline = 'e96f',
  grid = 'e903',
  photos = 'e911',
  artistParking = 'e90f',
  guestParking = 'e90e',
  eventSetUp = 'e90c',
  eventSetupOutline = 'e95b',
  fanExperience = 'e90b',
  fanExperienceOutline = 'e95c',
  rock = 'e900',
  noOutsideFood = 'e94b',
  smokingAllowed = 'e94c',
  cat = 'e94d',
  dog = 'e94f',
  cannabisFriendly = 'e950',
  foodForSale = 'e951',
  notAccessible = 'e952',
  noAlcohol = 'e953',
  noRedWine = 'e940',
  alcoholForSale = 'e94e',
  noSmoking = 'e959',
  noParking = 'e95a',
  covidProtocols = 'e954',
  overEighteen = 'e956',
  overNineteen = 'e956', // eslint-disable-line @typescript-eslint/no-duplicate-enum-values
  overTwentyone = 'e956', // eslint-disable-line @typescript-eslint/no-duplicate-enum-values
  overTwentyThree = 'e956', // eslint-disable-line @typescript-eslint/no-duplicate-enum-values
  overTwentyFive = 'e956', // eslint-disable-line @typescript-eslint/no-duplicate-enum-values
  stairs = 'e957',
  photoUpload = 'e95e',
  pinLocation = 'e960',
  multipleUsers = 'e961',
  microphoneStage = 'e962',
  party = 'e963',
  filmed = 'e964',
  messages = 'e965',
  note = 'e966',
  theme = 'e967',
  webpage = 'e968',
  display = 'e969',
  loading = 'e96a',
  cog = 'e96b',
  cogOutline = 'e970',
  cogQuestionMark = 'e973', // eslint-disable-line @typescript-eslint/no-duplicate-enum-values
  constructionSign = 'e971',
  locationUser = 'e96c',
  wrench = 'e96d',
  notApplicable = 'e96e',
  parkingRamp = 'e972',
  faceMaskRequired = 'e975',
  faceMaskNotRequired = 'e976',
}

export default Registry;
